<template>
    <div class="modal-mask" @click.self="$emit('fecharModal')">
        <div class="jm margem" style="min-width: 30vw; max-width: 70vw; max-height: 90vh; overflow: auto;" @click.stop>
            <template v-if="tarefa">
                <div class="alinha-centro m-b">
                    <h2>{{ tarefa.codigo ?? '–' }}</h2>
                </div>
                <fieldset class="grid-2">
                    <div class="col-2">
                        <label>Responsável</label>
                        <select v-model="tarefa.responsavel_id"
                            @change="atualizarTarefa({ responsavel_id: tarefa.responsavel_id })">
                            <option value="" hidden>Selecione</option>
                            <option v-for="item in usuarios" :key="item.id" :value="item.id">
                                {{ item.name || item.email }}
                            </option>
                        </select>
                    </div>

                    <div class="col-2">
                        <label>Descrição</label>
                        <textarea v-model="tarefa.descricao" rows="4"
                            @focusout="atualizarTarefa({ descricao: tarefa.descricao })"></textarea>
                    </div>

                    <div>
                        <label>Início Previsto</label>
                        <input v-model="dtInicioStr" type="date"
                            @change="atualizarTarefa({ dt_inicio: dtInicioStr || null })">
                    </div>
                    <div>
                        <label>Fim Previsto</label>
                        <input v-model="dtFimStr" type="date"
                            @change="atualizarTarefa({ dt_fim: dtFimStr || null })">
                    </div>

                    <div>
                        <label>Início Real</label>
                        <input v-model="dtInicioRealStr" type="date"
                            @change="atualizarTarefa({ dt_inicio_real: dtInicioRealStr || null })">
                    </div>
                    <div>
                        <label>Fim Real</label>
                        <input v-model="dtFimRealStr" type="date"
                            @change="atualizarTarefa({ dt_fim_real: dtFimRealStr || null })">
                    </div>

                    <div class="col-2">
                        <label>Observações</label>
                        <textarea v-model="tarefa.obs" rows="4"
                            @focusout="atualizarTarefa({ obs: tarefa.obs || null })"></textarea>
                    </div>

                    <!-- <div class="col-2">
                        <label>Status</label>
                        <BarraProgresso :prop-item="itemBarra" :id-usuario="idUsuario" :is-coordenador="true"
                            @editarStatus="(id, payload) => atualizarTarefa({ status: statusBarraParaApi(payload.status) })" />
                    </div> -->
                </fieldset>
            </template>
        </div>
    </div>
</template>

<script>
import { api } from 'roboflex-thalamus-request-handler';
// import BarraProgresso from '@/components/BarraProgresso.vue';

export default {
    name: 'ModalEditarTarefaReuniao',
    // components: { BarraProgresso },
    props: {
        propTarefa: { type: Object, required: true },
        propReuniaoId: { type: Number, required: true },
        usuarios: { type: Array, default: () => [] },
        idUsuario: { type: Number, default: null },
    },
    emits: ['fecharModal'],
    data() {
        return {
            tarefa: this.propTarefa ? { ...this.propTarefa } : null,
        };
    },
    watch: {
        propTarefa: {
            handler(val) {
                this.tarefa = val ? { ...val } : null;
            },
            immediate: true,
        },
    },
    computed: {
        dtInicioStr: {
            get() {
                if (!this.tarefa?.dt_inicio) return '';
                const s = this.tarefa.dt_inicio;
                return typeof s === 'string' && s.length >= 10 ? s.slice(0, 10) : s;
            },
            set(v) {
                if (this.tarefa) this.tarefa.dt_inicio = v || null;
            },
        },
        dtFimStr: {
            get() {
                if (!this.tarefa?.dt_fim) return '';
                const s = this.tarefa.dt_fim;
                return typeof s === 'string' && s.length >= 10 ? s.slice(0, 10) : s;
            },
            set(v) {
                if (this.tarefa) this.tarefa.dt_fim = v || null;
            },
        },
        dtInicioRealStr: {
            get() {
                if (!this.tarefa?.dt_inicio_real) return '';
                const s = this.tarefa.dt_inicio_real;
                return typeof s === 'string' && s.length >= 10 ? s.slice(0, 10) : s;
            },
            set(v) {
                if (this.tarefa) this.tarefa.dt_inicio_real = v || null;
            },
        },
        dtFimRealStr: {
            get() {
                if (!this.tarefa?.dt_fim_real) return '';
                const s = this.tarefa.dt_fim_real;
                return typeof s === 'string' && s.length >= 10 ? s.slice(0, 10) : s;
            },
            set(v) {
                if (this.tarefa) this.tarefa.dt_fim_real = v || null;
            },
        },
        itemBarra() {
            if (!this.tarefa) return null;
            const map = { pendente: 'Pendente', em_andamento: 'Em andamento', concluida: 'Concluído', cancelada: 'Cancelada' };
            return {
                id: this.tarefa.id,
                status: map[this.tarefa.status] ?? this.tarefa.status ?? 'Pendente',
                responsavel_id: this.tarefa.responsavel_id,
            };
        },
    },
    methods: {
        statusBarraParaApi(status) {
            return status ?? 'Pendente';
        },
        async atualizarTarefa(payload) {
            if (!this.tarefa?.id || !this.propReuniaoId) return;
            try {
                const { data } = await api.patch(
                    `google/calendar/reunioes/${this.propReuniaoId}/tarefas/${this.tarefa.id}`,
                    payload
                );
                if (data.tarefa) {
                    Object.assign(this.tarefa, data.tarefa);
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>
